export const SET_MAX = "SET_MAX";
export const SET_POST = "SET_POST";
export const LIKE_POST = "LIKE_POST";
export const CREATE_POST = "CREATE_POST";
export const APPEND_POST = "APPEND_POST";
export const REMOVE_POST = "REMOVE_POST";
export const UNLIKE_POST = "UNLIKE_POST";
export const POSTS_RECEIVED = "POSTS_RECEIVED";
export const SET_PROPERTY_POST = "SET_PROPERTY_POST";
